<template>
    <ul class="blog-nav">
        <li v-for="(entry, i) in blogIndex" :key="i" :class="{active: activeYear === entry.year}">
            <a :href="`/${entry.posts[0].id}`" @click.prevent="changePost(entry.posts[0].id)">{{ entry.year }}</a>
            <ul class="clearfix">
                <li v-for="(post, j) in entry.posts" :key="j" :class="{active: currentPostId === post.id}">
                    <a :href="`/${post.id}`" @click.prevent="changePost(post.id)">{{ post.title }}</a>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        blogIndex: {
            type: Array,
            required: true,
        },
        currentPostId: {
            type: Number,
            required: true,
        },
    },
    computed: {
        activeYear() {
            return this.blogIndex
                .find(entry => entry.posts.some(post => post.id === this.currentPostId))
                .year;
        },
    },
    methods: {
        changePost(id) {
            this.$emit('change-post', id);
        },
    },
}
</script>

<style scoped>
.blog-nav {
    float: left;
    width: 25%;
    padding: 20px;
    list-style: none;
    font-size: 0.9em;
    line-height: 1.4em;
}
.blog-nav ul {
    list-style: none;
    padding-left: 20px;
}
.blog-nav li > ul {
    display: none;
}
.blog-nav li.active > ul {
    display: block;
}
.blog-nav a {
    color: #333333;
}
.blog-nav li.active > a {
    color: #000000;
    font-weight: bold;
}

@media screen and (max-width:979px) { /* Small screens */
    .blog-nav {
        width: 100%;
    }
    .blog-nav > li > ul > li {
        float: left;
        width: 25%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding-right: 5px;
    }
}

@media screen and (max-width:767px) { /* Tablets */
    .blog-nav {
        padding: 10px;
    }
    .blog-nav > li > ul > li {
        width: 50%;
    }
}
</style>
